import { Chip, Link, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { CopyButton } from '@src/components/CopyButton'
import type { CreditAppMatchResult } from '@src/types/automationDocument'

interface CreditAppLinkProps {
  creditApp: CreditAppMatchResult | null
  possibleRefs?: string[]
}

export const CreditAppLink = ({ creditApp, possibleRefs }: CreditAppLinkProps) => {
  const { t, i18n } = useTranslation()

  if (creditApp) {
    const refNumber = creditApp.cvtNumber ?? creditApp.dccNumber
    const status = i18n.language === 'fr' ? creditApp.status : creditApp.statusEn

    return (
      <Stack direction="row" alignItems="center" gap={1} sx={{ width: '100%', height: '100%' }}>
        <Chip label={creditApp.formattedProductLine} size="small" variant="outlined" color="primary" />
        <Link
          href={`${import.meta.env.VITE_API_MONOLITH_URL}${creditApp.link}`}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          variant="body2"
          fontWeight={600}
          noWrap
        >
          #{refNumber}
        </Link>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {status}
        </Typography>
      </Stack>
    )
  }

  if (possibleRefs && possibleRefs.length > 0) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        gap={0.5}
        flexWrap="wrap"
        sx={{ width: '100%', height: '100%' }}
      >
        <Typography variant="caption" color="text.secondary">
          {t('docsAutomation.possibleRef')}
        </Typography>
        {possibleRefs.map((ref) => (
          <Stack key={ref} direction="row" alignItems="center" gap={0.25}>
            <Typography variant="body2" fontFamily="monospace">
              #{ref}
            </Typography>
            <CopyButton value={ref} label={t('common.copy')} />
          </Stack>
        ))}
      </Stack>
    )
  }

  return null
}
